export const AttHubAppType = 'volunteer';